<template>
    <div class="d-inline-flex align-center rounded c-quantity-changer" :class="{dense, expanded}">
        <v-btn :loading="loading"
               class="px-0 plus-minus rounded-ts rounded-bs border-s border-t border-b v-btn--variant-elevated text-body-3"
               :class="[smallText ? 'text-md-body-2' : 'text-md-body-1', size ? 'w-auto' : '']"
               :rounded="0"
               elevation="0"
               :size="size"
               @click="toAdd = plusMinus(toAdd, false)"
               :disabled="[0, 1].includes(toAdd) || disabled"
        >
            <v-icon :icon="mdiMinus"/>
        </v-btn>
        <input v-model="toAdd" type="number" min="1" class="c-quantity-changer__value border-t border-b justify-center text-center mt-0"
               :class="{
                'text-h6': smallText && $vuetify.display.mdAndUp,
                'text-h5': !smallText && $vuetify.display.mdAndUp,
                'px-4': expanded && $vuetify.display.lgAndUp,
                'px-2': expanded && $vuetify.display.mdAndDown,
                'small': $vuetify.display.smAndDown
            }" :style="{width: `${(length * 11) + (length > 1 ? ($vuetify.display.mdAndUp ? 20 : 0) : 20)}px!important`}"/>
        <v-btn :loading="loading"
               class="px-0 plus-minus rounded-te rounded-be border-e border-t border-b v-btn--variant-elevated text-body-3"
               :class="[smallText ? 'text-md-body-2' : 'text-md-body-1', size ? 'w-auto' : '']"
               :rounded="0"
               elevation="0"
               :size="size"
               @click="toAdd = plusMinus(toAdd, true, {limit:allowNoStock ? undefined : stock})"
               :disabled="allowNoStock ? false : toAdd === stock || stock === 0 || disabled"
        >
            <v-icon :icon="mdiPlus"/>
        </v-btn>

    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import {plusMinus} from "../utils/cart";
import {mdiMinus, mdiPlus} from "@mdi/js";
import {useDisplay} from "vuetify";

const props = defineProps({
    stock: Number,
    allowNoStock: {
      type: Boolean,
      default: true
    },
    modelValue: Number,
    dense: Boolean,
    expanded: Boolean,
    loading: Boolean,
    disabled: Boolean,
    hideValue: {
        type: Boolean,
        default: false
    },
    smallText: {
        type: Boolean,
        default: false
    },
    size: Number,
});
const toAdd = ref(props.modelValue || (props.stock ? 1 : 0));
const length = computed(() => {
    return Math.abs(toAdd.value).toString().length
});
watch(toAdd, (value) => {
    if (value === '')
        value = 1;
    emit('update:modelValue', Number(value));
})
watch(() => props.modelValue, (value) => {
    toAdd.value = value;
})
watch(() => props.stock, (val) => {
    if (val === 0) {
        if (props.allowNoStock) {
            toAdd.value = 1;
            return;
        }
        toAdd.value = 0;
        return;
    }
    if (val < toAdd.value) {
        toAdd.value = val;
        return;
    }
    if (val && !toAdd.value) {
        toAdd.value = 1;
    }
})
const emit = defineEmits(['update:modelValue']);
</script>

<style scoped lang="scss">
.c-quantity-changer {
    &:not(.dense) {
        --v-input-control-height: 48px;

        .plus-minus {
            height: var(--v-input-control-height);
        }
    }
    &.expanded {
        width: 100%;
    }
}

:deep(.v-btn) {
    min-width: 36px;
}

.c-quantity-changer__value {
    padding: 0!important;
    margin: 0;
    user-select: none;
    display: inline-flex;
    align-self: stretch;
    align-items: center;
    outline: none;
    flex: 1 1 auto;
}
.text-h6 {
    :deep(input) {
        font-size: 1.25rem;
    }
}
.text-h5 {
    :deep(input) {
        font-size: 1.5rem;
    }
}

.text-center-deep {
    :deep(input) {
        text-align: center;
        padding-top: 0;
    }

    .small {
        font-size: 1rem!important;
    }
}
</style>
